import type { ReportType } from '../../api/index.ts';

export interface ReportTypeOption {
  value: ReportType;
  label: string;
}

export const REPORT_TYPE_OPTIONS: ReportTypeOption[] = [
  { value: 'live', label: 'Live' },
  { value: 'demo', label: 'Demo' },
  { value: 'training', label: 'Training' },
];
